"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useKnockRequest", {
  enumerable: true,
  get: function get() {
    return _useKnockRequest["default"];
  }
});
var _useKnockRequest = _interopRequireDefault(require("./useKnockRequest"));